import React from "react";
import {
  buildSubscriptionAllowanceItems,
  getAllowanceUsagePercent,
} from "./planUtils";

const SubscriptionAllowancesPanel = ({
  user,
  subscription,
  title = "Allowances",
  compact = false,
  emptyMessage = "No allowance usage is available for this subscription yet.",
}) => {
  const items = buildSubscriptionAllowanceItems(user, subscription);

  if (!items.length) {
    return compact ? null : (
      <div className="stripe-subscription-allowances">
        <h5 className="stripe-subscription-allowances-title">{title}</h5>
        <p className="stripe-subscription-allowances-empty">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={`stripe-subscription-allowances${compact ? " is-compact" : ""}`}>
      <h5 className="stripe-subscription-allowances-title">{title}</h5>
      <div className="stripe-subscription-allowances-list">
        {items.map((item) => {
          const usagePercent = getAllowanceUsagePercent(item);

          return (
            <div key={item.key} className="stripe-subscription-allowance-item">
              <div className="stripe-subscription-allowance-item-header">
                <span className="stripe-subscription-allowance-label">{item.label}</span>
                <span className="stripe-subscription-allowance-value">
                  {item.unlimited ? (
                    "Unlimited"
                  ) : (
                    <>
                      <span className="stripe-subscription-allowance-used">{item.used ?? 0}</span>
                      <span className="stripe-subscription-allowance-separator">/</span>
                      <span className="stripe-subscription-allowance-total">{item.total ?? 0}</span>
                      <span className="stripe-subscription-allowance-remaining">
                        ({item.remaining ?? 0} left)
                      </span>
                    </>
                  )}
                </span>
              </div>
              {!item.unlimited && item.total > 0 && (
                <div
                  className="stripe-subscription-allowance-progress"
                  role="progressbar"
                  aria-valuenow={usagePercent}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label={`${item.label} usage`}
                >
                  <span
                    className="stripe-subscription-allowance-progress-bar"
                    style={{ width: `${usagePercent}%` }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubscriptionAllowancesPanel;
